// extracted by mini-css-extract-plugin
export default {"wrapper":"dictionary-editor_wrapper__ghhGy","tabs":"dictionary-editor_tabs__8N4ga"};